export const filters = [
	{ title: "Post Office", type: "POST OFFICE" },
	{ title: "Delivery Office", type: "Delivery Office", lightBlue: true },
	{ title: "PostPoint", type: "POSTPOINT", lime: true },
	{ title: "Parcel Locker", type: "PARCEL LOCKER", blue: true }
];

// hiding some features on the map
export const MapStyles = [
	{
		featureType: "poi.business",
		stylers: [{ visibility: "off" }]
	},
	{
		featureType: "transit",
		elementType: "labels.icon",
		stylers: [{ visibility: "off" }]
	},
	{
		featureType: "poi",
		elementType: "labels",
		stylers: [{ visibility: "off" }]
	},
	{
		featureType: "landscape",
		elementType: "labels",
		stylers: [{ visibility: "off" }]
	}
];

// dummy data while waiting from geo-directory data
export const locations = [
	{ name: "Dublin", lat: 53.34933275, lng: -6.26065885 },
	{ name: "Cork", lat: 51.910086, lng: -8.524505 },
	{ name: "Galway", lat: 53.300125, lng: -9.054621 }
];
